import { ref, computed } from 'vue';
import type { FaqCategory } from '~/handlers/ports/api-fetch-faq.port';
import { fetchFaqHandler } from '~/handlers/fetch-faq.handler';

// Estado compartilhado entre todas as instâncias do composable.
// Como é SPA com uma única montagem do componente FAQ, isso evita
// re-fetches desnecessários ao navegar entre rotas.
const categories = ref<FaqCategory[]>([]);
const loading = ref(false);
const fetched = ref(false);

export const useFaq = () => {
  const fetchFaq = async () => {
    if (fetched.value) return;

    loading.value = true;

    try {
      const result = await fetchFaqHandler();

      categories.value = result.filter((cat) => cat.items.length > 0);
      fetched.value = true;
    } catch (error) {
      console.error('Error in useFaq:', error);
    } finally {
      loading.value = false;
    }
  };

  return {
    fetchFaq,
    categories: computed(() => categories.value),
    loading: computed(() => loading.value),
    hasCategories: computed(() => categories.value.length > 0),
  };
};
